<template>
<div class="letter_circle" v-bind:style="styleObject">
        {{ avatar.getLetter() }}
</div>
</template>

<script>
export default {
    props: {
        avatar: {
            type: Object,
            default: function() { return {}; },
        },

        no_margin: {
            type: Boolean,
            default: function() { return false; },
        }
    },

    computed: {
        styleObject() 
        {
            return {
                'background-color': this.avatar.getColor(),
                'margin-bottom': this.no_margin ? '0px' : '15px'   
            };
        }
    },
}
</script>

<style scoped>

div.letter_circle 
{
    width: 40px;
    line-height: 40px;
    border-radius: 50%;
    text-align: center;
    font-size: 22px;
   
    background-color: rgb(175, 92, 247);
    color: white;


    font-family: "Google Sans",Roboto,arial,sans-serif;
    font-weight: 400;
    text-transform: uppercase;

 
}

</style>